import { css } from 'emotion';
import { tabletPortraitMaxWidthBreakpoint, lightGrey, grey } from 'inside-out/global-styles';

export const skipLinksStyle = css({
	position: 'absolute',
	left: '-9999999px',
});

export const wrapperStyle = css({
	width: '100%',
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		'& [data-component=GreyBar]': {
			display: 'none',
		},
	},
});

export const mobileNavOverlay = css({
	//opacity: '0',
	position: 'fixed',
	zIndex: '2',
	top: '0',
	left: '0',
	width: '100%',
	height: '100%',
	background: 'rgba(0,0,0,0.7)',
	overflow: 'hidden',
});

export const closeIconStyle = css({
	display: 'inline-block',
	width: '24px',
	height: '24px',
	position: 'absolute',
	top: '24px',
	right: '24px',
	padding: '0',
	border: '0',
});

export const primaryMobileNavStyle = css({
	background: lightGrey,
});

export const secondaryMobileNavStyle = css({
	borderBottom: `1px solid ${lightGrey}`,
});

export const mobileNavStyle = css({
	position: 'absolute',
	zIndex: '3',
	top: 0,
	//right: '100%',
	right: '0',
	width: '300px',
	height: '100%',
	background: '#fff',
	overflow: 'auto',
	'& nav': {
		padding: '24px',
		'& > a': {
			color: grey,
			fontSize: '14px',
			lineHeight: '17px',
			display: 'block',
			margin: '24px 0',
			textDecoration: 'none',
			'&:first-child': {
				marginTop: 0,
			},
			'&:last-child': {
				marginBottom: 0,
			},
		},
		'&:first-of-type': {
			paddingTop: '75px',
		},
	},
});



// WEBPACK FOOTER //
// ./src/layouts/main.styles.js